<template>
  <div>
    <div id="album">
      <div id="title" class="mobile">{{ $t('tabBar.album') }}</div>
      <div id="photos">
        <div v-for="photo in photos" class="image-wrapper">
          <image-view
            class="image"
            :src="photo.image && photo.image.url"
            group="albumPhotos"
            :title="photo.title"
            vImgEnabled="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import getAlbumPhotos from '../models/AlbumPhoto';
import ImageView from './ImageView';

export default {
  name: 'Album',
  components: {
    'image-view': ImageView,
  },
  data() {
    return {
      photos: [],
    };
  },
  mounted() {
    getAlbumPhotos().then((records) => {
      this.photos = [...records];
    });
  },
};
</script>

<style lang="sass" scoped>
  @import "../styles/variables.sass"

  #album
    margin-top: 40px
    margin-bottom: 40px

    @media #{$mobile}
      margin-top: 30px
      margin-bottom: 30px
    
  #photos
    display: flex
    max-width: 860px
    flex-wrap: wrap
    margin: 0 auto

    @media #{$desktop-small}
      max-width: 575px

    @media #{$mobile}
      max-width: 288px

  #title
    font-size: 24px
    color: $flamingo
    text-align: center
    margin-bottom: 30px

  .image-wrapper
    padding: 14px 10px

  .image
    border: 1px solid $silver
    width: 266px
    height: 210px

</style>



// WEBPACK FOOTER //
// src/components/Album.vue